/**
 * Display helpers for member identity strings.
 *
 * Privacy: full last names are NEVER stored. We only ever combine the user's
 * first name with their optional last-name initial (e.g. "TK W.").
 */

/**
 * Compose a privacy-safe display name from a first name and an optional
 * last-name initial. Examples:
 *   ("TK", "W")  -> "TK W."
 *   ("TK", "W.") -> "TK W."
 *   ("TK", null) -> "TK"
 *   (null, "W")  -> "W."
 *   (null, null) -> ""  (caller should fall back)
 */
export const formatDisplayName = (firstName, lastInitial) => {
  const first = (firstName || '').trim();
  let initial = (lastInitial || '').trim().toUpperCase();
  if (initial && !initial.endsWith('.')) initial += '.';
  if (first && initial) return `${first} ${initial}`;
  return first || initial || '';
};

/**
 * Format pronouns for muted secondary display. Returns null when pronouns
 * are missing, blank, or set to "Prefer not to say" (so callers can hide
 * the element entirely in that case).
 *   "He/Him"             -> "(He/Him)"
 *   "Prefer not to say"  -> null
 *   null / ""            -> null
 */
export const formatPronouns = (pronouns) => {
  const p = (pronouns || '').trim();
  if (!p || p === 'Prefer not to say') return null;
  return `(${p})`;
};
